import { createAction, props } from "@ngrx/store";
import { Language } from "cli-types";

export const loadLanguages = createAction("[Profile] Load Languages");
export const loadLanguagesFail = createAction("[Profile] Load Languages Fail", props<{ payload: any }>());
export const loadLanguagesSuccess = createAction("[Profile] Load Languages Success", props<{ payload: Language[] }>());
